<template>
  <div>
    <div v-if="isLoading" class="input_select-loading"></div>
    <div v-else class="input_select" v-click-outside="() => { show = false; }">
      <div @click="show = !show" ref="inputSelectBox" class="input_select-box">
        <div class="input_select-name">{{ selectName }}</div>
        <div class="input_select-right">
          <div
            :class="[
              'input_select-tri',
              show ? 'input_select-tri--revere' : '',
            ]"
          ></div>
        </div>
      </div>
      <div
        ref="inputSelectListBox"
        :class="[
          'input_select-list-box',
          show ? 'input_select-list--show' : 'input_select-list--hide',
        ]"
      >
        <ul class="input_select-list-wrap">
          <li
            v-for="(item, index) in list"
            :key="index"
            @click="handleSelect(item.id)"
            class="input_select-list"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },

    list: {
      type: Array,
      required: true,
    },

    defaultId: {
      required: true,
    },
  },

  data() {
    return {
      show: false,
      select: '',
    }
  },

  computed: {
    selectName() {
      return this.list.find(x => x.id === this.select).name
    }
  },

  methods: {
    handleSelect(id) {
      this.show = false
      this.select = this.list.find(x => x.id === id).id

      this.$emit('change', this.select)
    },

    setList() {
      if (this.list.length > 0) {
        const inputSelectBox = this.$refs.inputSelectBox
        const inputSelectListBox = this.$refs.inputSelectListBox
  
        inputSelectListBox.style.top = `${inputSelectBox.offsetHeight + 10}px`
      }
    },
  },

  created() {
    this.select = this.defaultId
  },

  mounted() {
    this.setList()
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.input_select {
  position: relative;
  margin-top: 32px;
  margin-bottom: 32px;
  max-width: 450px;
  width: 100%;

  &-loading {
    @include skeleton;
    width: 360px;
    height: 36px;
    border-radius: 4px;
  }

  &-box {
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-height: 40px;
    width: 100%;
    height: fit-content;
    border-radius: 4px;
    border: 2px solid #e42200;
    background-color: #ffffff;
  }

  &-name {
    padding: 0 20px;
    width: calc(100% - 56px);
    text-transform: uppercase;
    text-align: center;
    font-weight: 700;
    font-size: 1.5rem;
    color: #000000;
  }

  &-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 16px;
    width: 56px;
    height: 18px;
    border-left: 2px solid #e42200;
  }

  &-tri {
    transition: 400ms ease;
    clip-path: polygon(0 0, 100% 0, 50% 100%);
    width: 14px;
    height: 10px;
    background-color: #e42200;

    &--revere {
      clip-path: polygon(0 100%, 100% 100%, 50% 0);
    }
  }

  &-list {
    cursor: pointer;
    padding: 6px;
    text-transform: uppercase;
    text-align: center;
    font-weight: 700;
    font-size: 1.5rem;
    color: #ffffff;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);

    &:hover,
    &:focus {
      color: #e42200;
    }

    &-wrap {
      list-style: none;
    }

    &-box {
      display: none;
      position: absolute;
      z-index: 100;
      left: 0;
      padding-top: 6px;
      padding-bottom: 6px;
      width: 100%;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.85);
      backdrop-filter: blur(4px);
    }

    &--hide {
      animation: hide 400ms ease forwards;

      @keyframes hide {
        0% {
          display: block !important;
          opacity: 1;
          transform: translateY(0);
        }

        99% {
          opacity: 0;
          transform: translateY(-10px);
        }

        100% {
          display: none;
        }
      }
    }

    &--show {
      animation: show 400ms ease forwards;
      display: block;

      @keyframes show {
        0% {
          opacity: 0;
          transform: translateY(-10px);
        }

        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
    }
  }
}
</style>